export default __webpack_public_path__ + "static/media/featured-item-6.61f38e67.png";